import { Flex, Spin } from 'antd';
import { useBreakpoint } from '@/shared/lib/hooks';
import { fullScreenMinHeight } from '@/shared/lib/mobileUi';

/** What the page shows while the first route's code is still being loaded (the routes are lazy). */
export function InitialLoading() {
  const { isMobile } = useBreakpoint();
  return (
    <Flex align="center" justify="center" style={{ minHeight: fullScreenMinHeight(isMobile) }}>
      <Spin size="large" />
    </Flex>
  );
}
